import { PostHog } from '@posthog/types';

/**
 * PostHog is initialized in `resources/views/app.blade.php` on `window.posthog`.
 * The `posthog-js` npm default export is a different, uninitialized singleton — do not use it here.
 */
export function getPosthog(): PostHog | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return window.posthog;
}
